var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellstatSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A1A1A;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "20.2,370 77.9,370 77.9,263.9 20.2,263.9  ",
    id: "id_107",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "95.7,370 153.4,370 153.4,238.4 95.7,238.4  ",
    id: "id_108",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "171.1,370 228.9,370 228.9,200 171.1,200  ",
    id: "id_109",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "246.6,370 304.3,370 304.3,155.2 246.6,155.2  ",
    id: "id_110",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "322.1,370 379.8,370 379.8,108.6 322.1,108.6  ",
    id: "id_111",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.3,59c0-0.5-0.1-0.9-0.2-1.4c-0.1-0.4,0-0.8-0.1-1.2c0-0.2-0.1-0.3-0.2-0.5c0-0.1,0-0.2-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3c-0.4-0.9-0.8-1.7-1.5-2.4c0-0.1-0.1-0.2-0.2-0.2c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.2-0.1 c-0.7-0.7-1.4-1.2-2.3-1.7c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-0.8-0.3-1.8-0.5-2.7-0.6 c-0.1,0-0.1,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.7,0-1.5,0.1-2.3,0.3l-68.6,20.3c-4.6,1.3-7.2,6.3-5.9,11c1.1,3.9,4.5,6.5,8.3,6.5 c0.8,0,1.6-0.1,2.4-0.3l33.1-9.8C201,135.7,118.6,175.9,27.1,195c-4.6,1-7.6,5.7-6.7,10.5c0.8,4.2,4.4,7.1,8.4,7.1 c0.6,0,1.1-0.1,1.7-0.2c93.2-19.4,177.3-60.3,245.6-118.8l-9.7,22.2c-1.9,4.5,0,9.8,4.3,11.8c1.2,0.5,2.4,0.8,3.5,0.8 c3.3,0,6.4-1.9,7.8-5.2l26.5-60.6c0,0,0-0.1,0-0.1c0.2-0.4,0.2-0.9,0.3-1.3c0.1-0.5,0.3-1,0.4-1.6C309.2,59.4,309.3,59.2,309.3,59 L309.3,59z",
    id: "id_112",
    style: {
      fill: "current"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellstatSelected);
export default __webpack_public_path__ + "static/media/sellstat_selected.f89553363c96b6590cedd9eba15c47ab.svg";
export { ForwardRef as ReactComponent };